(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Annotorious"] = factory();
	else
		root["Annotorious"] = root["Annotorious"] || {}, root["Annotorious"]["SelectorPack"] = factory();
})(self, () => {
return 